import AnalyticsPoint from 'gatsby-plugin-purina-analytics/AnalyticsPoint';
import React, { useContext } from 'react';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import BreedCard from '../breed_card/BreedCard';
import BreedCardSkeleton from '../breed_card/BreedCardSkeleton';
import NoResults from './NoResults';
import { SearchListingContext } from './SearchListingContext';

interface Props {
  serverData?: DrupalSearch;
}

const BreedSearchResults: React.FC<Props> = function ({ serverData }) {
  const context = useContext(SearchListingContext);

  if (!context) {
    throw new Error(
      'Child components of SearchListing cannot be rendered outside the SearchListing component!',
    );
  }

  const { data, loaded } = context || {};
  const search_results = serverData?.search_results || data?.search_results || ({} as DrupalSearch);

  if (!loaded) {
    return (
      <Row className="mb-5 gy-3 gy-md-4 gx-2 gx-md-3">
        {[...Array(12)].map((_, i) => {
          return (
            <Col key={`loading-card-${i}`} xs={6} md={4} className="d-flex">
              <BreedCardSkeleton />
            </Col>
          );
        })}
      </Row>
    );
  }

  if (!search_results) {
    return <NoResults />;
  }

  return (
    <Row id="search-results" className="mb-5 gy-3 gy-md-4 gx-2 gx-md-3">
      {Object.values(search_results as BreedSearchResult[]).map(node => {
        const image = node.field_media_image
          ? process.env.GATSBY_DRUPAL_ENDPOINT + node.field_media_image.substring(1)
          : '';

        return (
          <Col key={node.nid} xs={6} md={4} className="d-flex">
            <AnalyticsPoint
              type="component"
              category="search_result_selected"
              action={node.title}
              eventLabel="breeds"
              node={{ ...node, name: node.title, id: '', type: 'breed_card' }}
            >
              <BreedCard
                image={{
                  images: {
                    fallback: {
                      src: image,
                    },
                  },
                  layout: 'constrained',
                  width: 400,
                  height: 400,
                }}
                link={node.url}
                title={node.title}
              />
            </AnalyticsPoint>
          </Col>
        );
      })}
    </Row>
  );
};

BreedSearchResults.displayName = 'SearchListing.BreedSearchResults';

export default BreedSearchResults;
